module.exports = "/_next/static/images/bitcat-f98d8831638422b56f83e3f8ef8cf982.png";